module.exports = __webpack_public_path__ + "img/logoend.60cabe8c.png";